/**
 * Created by shubham on 8/5/18.
 */

import { Component } from '@angular/core';
import { APPCONFIG } from '../config';
import { MdDialog } from '@angular/material';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { HttpService } from '../shared/services/http.service';
import { SessionHandler } from '../shared/services/session-handler.service';
import { dialogComponent } from '../dialog/dialog.component';
import { Headers } from '@angular/http';
import {Router, ActivatedRoute, Params} from '@angular/router';
import { AuthService } from "angularx-social-login";


@Component({
    selector: 'configurationsComponent',
    template: require('./configurations.component.html'),
    providers: [HttpService, SessionHandler]

})
export class ConfigurationsComponent {

    dialogRef;
    userDetails: any;
    isSystemAdmin:boolean = false;
    isCountryManager:boolean = false;
    countries = []
    selectedCountries = [];
    countryMessage = '';
    AdminForm: FormGroup;
    AdminFormDetails: any;
    isDisabled = true;
    countrySettings = {};
    report_json = {};
    action:string;
    id:string;
    configObj :any = {};
    showLoader = false;
    actionTitle:string;

    constructor(private sessionHandler:SessionHandler, public httpService : HttpService, public dialog: MdDialog, private formBuilder: FormBuilder
        ,private activatedRoute: ActivatedRoute,private router: Router, private authService: AuthService) {

        this.authService.authState.subscribe((user) => {
            if(user != null){
                var that = this;
                this.activatedRoute.params.subscribe(params => {
                    that.action = params['action'];
                });
                this.activatedRoute.queryParams.subscribe((params: Params) => {
                    that.id = params['id'];
                });
                if("Create" ==  that.action){
                    this.getDefaultFormData();
                    this.actionTitle = "Add";
                }else{
                    this.getEditForm(that.id);
                    this.actionTitle = "Edit";
                }
            }
        });
    }
    public getEditForm(id){
        this.showLoader = true;

        let token = localStorage.getItem('userEmail');
        const httpOptions = {
          headers : new Headers({
                'Content-Type': 'application/json',
                'googleEmailId': token
            }) };
        this.httpService.getRequestWithHeader('configurations/edit/'+this.id, httpOptions).subscribe(
            res => {
                console.log(res);

                
                if(res['message'] == 'error_occured'){

                    this.showLoader = false;
        
                    this.httpService.onEnd();
                    this.dialogRef = this.dialog.open(dialogComponent);
                    this.dialogRef.componentInstance.msg = res['exp']['message'];
        
                    this.dialogRef.afterClosed().subscribe(result => {
                        window.location.href = '#/app/configs/list';
                    });
                    return;
                 }
                this.report_json = res['dataMap'];
                // console.log(this.report_json);

                let countriesArr = this.report_json['countries'];
                this.configObj = this.report_json['config'];
                
               
                for (var i in countriesArr) {
                    var obj = { "id": i+'', "name": countriesArr[i] };
                    this.countries.push(obj);
                    if(this.configObj.country==countriesArr[i]){
                        this.selectedCountries.push(obj);
                    }
                }
                // this.selectedRole.push({ "id": selectedRoleIndex+'', "name": this.user.role });
                // this.selectedCountries = this.report_json['selectedCountries'];

               
                this.configObj.countriesData = this.selectedCountries;

                // this.selectedCountries.push({ "id": 0, "name": countriesArr[0] });
                this.countryMessage = "";
                this.httpService.onEnd();
                this.showLoader = false;
                this.buildForm();
                this.AdminForm.patchValue(this.configObj);
                
                                // this.buildForm();


                },
                err => {
                    this.dialogRef = this.dialog.open(dialogComponent);
                    this.dialogRef.componentInstance.msg = 'Failed to retrieve data.';
                    this.showLoader = false;
                    this.httpService.onEnd();
                    }
        );  
    }
    public getDefaultFormData(){
          
        this.showLoader = true;
            let token = localStorage.getItem('userEmail');
            const httpOptions = {
              headers : new Headers({
                    'Content-Type': 'application/json',
                    'googleEmailId': token
                }) };
            this.httpService.getRequestWithHeader('configurations/create', httpOptions).subscribe(
                res => {
                    console.log(res);
    
                    if(res['message'] == 'error_occured'){
    
                        this.showLoader = false;
            
                        this.httpService.onEnd();
                        this.dialogRef = this.dialog.open(dialogComponent);
                        this.dialogRef.componentInstance.msg = res['exp']['message'];
            
                        this.dialogRef.afterClosed().subscribe(result => {
                            window.location.href = '#/app/configs/list';
                        });
                        return;
                     }
    
    
                    this.report_json = res['dataMap'];
                    console.log(this.report_json);
    
                    let countriesArr = this.report_json['countries'];
                   
                    for (var i in countriesArr) {
                        var obj = { "id": i, "name": countriesArr[i] };
                        this.countries.push(obj);
                    }
                    // this.selectedRole.push({ "id": 0, "name": rolesArr[0] });
                    // this.selectedCountries.push({ "id": 0, "name": countriesArr[0] });
                    // this.countryMessage = "";
                    // this.roleMessage = "";
                    this.httpService.onEnd();
                    this.showLoader = false;
                    // this.buildForm();
    
    
                    },
                    err => {
                        this.dialogRef = this.dialog.open(dialogComponent);
                        this.dialogRef.componentInstance.msg = 'Failed to retrieve data.';
                        this.showLoader = false;
                        this.httpService.onEnd();
                        }
            );  
          }

    buildForm() {
        this.AdminForm = this.formBuilder.group({
            downloadLimit: this.formBuilder.control('5', [Validators.min(1), Validators.pattern('^[0-9]*$')]),
            passwordExpiryDays: this.formBuilder.control('60', [Validators.min(1), Validators.pattern('^[0-9]*$')]),
            //  emailTemplate: this.formBuilder.control(null, [Validators.required]),   
             countriesData: this.formBuilder.control(null, [Validators.required]),         
        });
        this.AdminForm.valueChanges.subscribe(data => {
            this.AdminFormDetails = this.AdminForm.getRawValue();

            this.AdminFormDetails['countryId'] = [];
            
            this.AdminFormDetails['country'] = null;


            // console.log( this.AdminFormDetails.roleData.size);
            // console.log( this.AdminFormDetails['roleId']);
          
            for (let d in this.AdminFormDetails.countriesData){
                this.AdminFormDetails['countryId'].push(this.AdminFormDetails.countriesData[d]['id']);
                this.AdminFormDetails['country']=this.AdminFormDetails.countriesData[d]['name'];
            }
            // console.log( this.AdminFormDetails['roleId']);
// console.log(this.AdminFormDetails['roleId'].length);

              if(this.AdminFormDetails['countryId'].length==0){
                this.AdminFormDetails.validate = false;
                this.countryMessage = "Select Country";
                }else{
                    this.AdminFormDetails.validate = this.AdminForm.valid;
                    this.countryMessage = '';
                }
        });
      
    }

    public saveAdminData(){

        // console.log(this.AdminForm.value);
        console.log(this.AdminFormDetails);

        const config = this.AdminFormDetails;
        config.id = this.id;
        // console.log(user);

        // let body = JSON.stringify(user);
        this.showLoader = true;

        let token = localStorage.getItem('userEmail');
        const httpOptions = {
          headers : new Headers({
                'Content-Type': 'application/json',
                'googleEmailId': token
            }) };
        this.httpService.postRequestWithHeader(config,'configurations/create',httpOptions).subscribe(
            res => { this.saveAdminResponse(res); 
            
            },
            err => { this.httpService.onEnd(); 
                this.showLoader = false;

            }
        );
    }

    public saveAdminResponse(res){
        console.log(res);
            var jsonResponse = JSON.parse(res['_body']);
        if(jsonResponse && jsonResponse.message == 'success'){
          
            this.showLoader = false;

            this.httpService.onEnd();
            this.dialogRef = this.dialog.open(dialogComponent);
            if(this.action=='Edit'){
                this.dialogRef.componentInstance.msg = "Configuration updated successfully.";
            }else{
                this.dialogRef.componentInstance.msg = "Configuration added successfully.";
            }
            this.dialogRef.afterClosed().subscribe(result => {
                window.location.href = '#/app/configs/list';
            });
        }else if(jsonResponse && jsonResponse.message == 'error_occured'){

            this.showLoader = false;

            this.httpService.onEnd();
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = jsonResponse.exp.message;

        
         } else {
            this.showLoader = false;

            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = 'Not able to save details. Please try again.';
            this.httpService.onEnd();
        }
    }

    ngOnInit() {
        this.buildForm();
        this.countrySettings = {
            singleSelection: true,
            text:"Select Country *",
            labelKey: "name",
            // selectAllText:'Select All',
            // unSelectAllText:'UnSelect All',
            classes:"myclass custom-class"
        };

          }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/configurations/configurations.component.ts